<div class="dvb-kita-faktura-rechnungen-frist-filter">
    <button class="btn label label-default label-radio"
            type="button"
            ng-model="vm.filter.abgelaufen"
            ng-click="vm.onUpdate()"
            uib-btn-checkbox
            data-translate="FAKTURA.RECHNUNG_FILTER.RECHNUNG_FILTER_ABGELAUFEN">
    </button>
</div>
